import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

function Aboutus() {
    const [pageTitle,setPageTitle] = useState('About Us');
    const [pageContent,setPageContent] = useState('');
    useEffect(() => {
        getData()
    }, []);

    const getData = async () => {
        try {
            const response = await fetch('https://api.kahaaniplus.com/api/v1/page/about-us');
            const data = await response.json();
            setPageTitle(data.data.page_title);
            setPageContent(data.data.page_content);
            console.log(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        <Row>
            <Col md={12} sm={12} xs={12} className='mt-5'>
                <h1 className='text-center'>{pageTitle}</h1>

            </Col>
            <Col md={12} xs={12} sm={12}>
                <p className='my-para'   dangerouslySetInnerHTML={{ __html: pageContent }} >
                   

                {/*     <b>Introduction</b><br/>
                    Our website, www.kahaaniplus.in (“Kahaani Plus”), 
                    a product of TIARA DIGITAL SERVICES PRIVATE LIMITED (“I, We, Us”)is a premier online 
                    destination dedicated to providing a wide range of e-books across various genres 
                    and categories to readers worldwide. We are committed to enriching the reading experience of our users by offering an extensive digital library that caters to diverse interests and preferences.<br/>

                    <b>Our Mission</b><br/>
                    That the mission of Kahaani Plus is to democratize access to information and literature, making it accessible to everyone, everywhere, at any time. We strive to support the reading community by providing an easy-to-use platform where users can explore, purchase, and enjoy e-books from the comfort of their devices.<br/>

                    <b>Our Vision</b><br/>
                    That we envision a world where every individual has the opportunity to learn, grow, and be entertained through the power of digital reading. Kahaani Plus aims to be at the forefront of the digital reading revolution, fostering a global community of readers and authors connected through stories and ideas.<br/>

                    <b>Our Values</b><br/>
                    1.      Customer Focus: That we prioritize the needs and satisfaction of our readers, continuously enhancing our platform and services to deliver an exceptional user experience.<br/>
                    2.      Innovation: That we embrace technology and innovation, constantly seeking new ways to improve access to e-books and enrich the reading experience.<br/>
                    3.      Integrity: That we conduct our business with the highest ethical standards, ensuring fairness, transparency, and respect in all our interactions.<br/>
                    4.      Diversity and Inclusion: That we celebrate diversity in literature and strive to offer a platform that is inclusive, providing a space for voices from all walks of life to be heard.<br/>
                    5.      Sustainability: That we are committed to sustainable practices, promoting digital reading as an environmentally friendly alternative to traditional print books.<br/>

                    <b>Our Collection</b><br/>
                    That Kahaani Plus boasts an expansive collection of e-books ranging from classic literature to contemporary bestsellers, academic texts, and niche genres. We partner with authors and publishers around the globe to continuously update our library, ensuring that our users have access to the latest and most sought-after titles.<br/>
                    <b>Our Technology</b><br/>
                    That our platform is built on cutting-edge technology designed to provide a seamless and intuitive user experience. From advanced search filters and personalized recommendations to user-friendly reading interfaces, we ensure that our readers can easily find and enjoy their preferred e-books.<br/>

                    <b>Our Community</b><br/>
                    That we believe in the power of community and actively foster engagement through reader reviews, author interviews, and interactive discussions. Kahaani plus is not just a platform for reading e-books; it is a vibrant community where readers and writers connect and share their passion for literature.<br/>

                    <b>Contact Us</b><br/>
                    That we welcome feedback and inquiries from our users. For support, suggestions, or more information about Kahaani Plus, please contact us at contactus@tiaradigital.in or 9867893783<br/>

                    At Kahaani Plus, we are passionate about making reading accessible and enjoyable for everyone. We invite you to explore our digital library and discover the endless possibilities that await you in the world of e-books.
 */}

                </p>

            </Col>

        </Row>
    )
}

export default Aboutus